import { getQueryParam } from "../configs/configLoader";

interface PrivacyPolicyConfig {
  urls: {
    default: string;
    [market: string]: string | Record<string, string>;
  };
}

export function resolvePrivacyPolicyUrl(
  config: PrivacyPolicyConfig | undefined,
): string | undefined {
  if (!config?.urls) return undefined;

  const market = (
    getQueryParam("countryCode") ||
    getQueryParam("market") ||
    ""
  ).toUpperCase();
  const lang = getQueryParam("lang") || "";

  const marketUrls = config.urls[market];

  if (marketUrls && typeof marketUrls === "object") {
    if (lang && marketUrls[lang]) return marketUrls[lang];
    return marketUrls.default;
  }

  return config.urls.default;
}
